import { useCallback, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useQuery } from 'data-fetching-client';
import { Text } from 'foundations-components/components/Text';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIModal from 'UIComponents/dialog/UIModal';
import { computeModalContent } from './deleteSubmissionModalUtils';
import { DELETE_FORECAST_SUBMISSION } from './api/deleteSubmissionApi';
import { logRavenException } from '../../utils/ravenWrapperUtil';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DeleteSubmissionModal = ({
  forecastSubmission,
  forecastSubmissionId,
  forecastSubmissionTimestamp,
  handleCancel,
  handleConfirmation,
  handleError,
  isMostRecentSubmissionInPeriod,
  isPeriodCompleteForAccuracy,
  isSubmissionForUser,
  isSubmissionOnlyRemaining,
  userSubmissionAmount
}) => {
  const [isDeleteConfirmed, setIsDeleteConfirmed] = useState(false);
  const {
    data,
    loading
  } = useQuery(DELETE_FORECAST_SUBMISSION, {
    variables: {
      forecastSubmissionId,
      forecastSubmissionTimestamp
    },
    skip: !isDeleteConfirmed,
    onCompleted: handleConfirmation,
    onError: error => {
      logRavenException(error, 'Delete forecast submission');
      handleError();
    }
  });
  const handleClickDelete = useCallback(() => {
    setIsDeleteConfirmed(true);
  }, []);
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "danger",
    width: 540,
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "deleteSubmissionModal.title"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: handleCancel
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: loading || data ? /*#__PURE__*/_jsx(UILoadingSpinner, {
        layout: "centered",
        grow: true
      }) : computeModalContent({
        forecastSubmission,
        forecastSubmissionTimestamp,
        isMostRecentSubmissionInPeriod,
        isPeriodCompleteForAccuracy,
        isSubmissionForUser,
        isSubmissionOnlyRemaining,
        userSubmissionAmount
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        onClick: handleClickDelete,
        use: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "deleteSubmissionModal.confirmDelete"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: handleCancel,
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "deleteSubmissionModal.cancel"
        })
      })]
    })]
  });
};
export default DeleteSubmissionModal;